/**
 * Created by charles on 2018/4/24.
 */
export function getCookie (name) {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

export function setCookie (name, value, days = 30, path = '/', domain) {
  let Days = days;
  let exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  let curCookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=" + path;
  if (domain) {
    curCookie += ";domain=" + domain;
  }
  document.cookie = curCookie;
  
}

export function removeCookie (name, path='/', domain) {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  let curCookie = "";
  if (cval !== null) {
    curCookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=" + path;
  }
  if (domain) {
    curCookie += ";domain=" + domain;
  }
  document.cookie = curCookie;
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js